var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIstatistik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_1686_771)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 7.5C13.0728 7.5 13.3594 7.70657 13.4615 8.01283L17.25 19.3783L18.7885 14.7628C18.8906 14.4566 19.1772 14.25 19.5 14.25H22.5C22.9142 14.25 23.25 14.5858 23.25 15C23.25 15.4142 22.9142 15.75 22.5 15.75H20.0406L17.9615 21.9872C17.8594 22.2934 17.5728 22.5 17.25 22.5C16.9272 22.5 16.6406 22.2934 16.5385 21.9872L12.75 10.6217L11.2115 15.2372C11.1094 15.5434 10.8228 15.75 10.5 15.75H7.5C7.08579 15.75 6.75 15.4142 6.75 15C6.75 14.5858 7.08579 14.25 7.5 14.25H9.95943L12.0385 8.01283C12.1406 7.70657 12.4272 7.5 12.75 7.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_771",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C44D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIstatistik);
export default __webpack_public_path__ + "static/media/istatistik.0cbdb3ba41b1b6d7e0acbda6bba8e9d7.svg";
export { ForwardRef as ReactComponent };